import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

export const fetchTMDBTVShows = createAsyncThunk(
  "tmdb/tvShows",
  async (title) => {
    const response = await axios.get(
      `${BASE_URL}/api/tmdb/tvshows?title=${title}`
    );
    return response.data;
  }
);

const tmdbTVShowSlice = createSlice({
  name: "tmdbTVShows",
  initialState: {
    tmdbTVShows: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    clearTMDBTVShows: (state) => {
      state.tmdbTVShows = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch tmdb tv shows
      .addCase(fetchTMDBTVShows.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTMDBTVShows.fulfilled, (state, action) => {
        state.tmdbTVShows = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchTMDBTVShows.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearTMDBTVShows } = tmdbTVShowSlice.actions;

export default tmdbTVShowSlice.reducer;
